<template>
	<div class="footers">
		<footer class="main-footer">
			<div class="footer-nav">
				<div class="columns column3">
					<p>
						<span>
							{{ defaults[locale].website.street }}
							{{ defaults[locale].website.number }}</span
						>
						<br />
						<span>{{ defaults[locale].website.postalCode }} {{ defaults[locale].website.city }}</span>
						<br />
						<span>{{ defaults[locale].website.country }}</span>
						<br />
						<a :href="`tel:${$phoneRaw(defaults[locale].website.phone)}`">
							<span>{{ defaults[locale].website.phone }}</span>
						</a>
						<br />
						<a :href="`mailto:${defaults[locale].website.email}`">
							<span>{{ defaults[locale].website.email }}</span>
						</a>
						<br />
					</p>
				</div>
				<div class="columns column5">
					<div v-parse-links v-html="openinghours" />
				</div>
				<div class="columns column4">
					<p class="align-right">
						<span v-for="item in footermenu[locale]" :key="item.filename">
							<nuxt-link :to="item.filename">
								{{ item.header }}
							</nuxt-link>
						</span>
						<span>
							<a href="#" @click.prevent="openConsent">{{ $t('consentOpen') }}</a>
						</span>
					</p>
				</div>
			</div>
		</footer>
	</div>
</template>

<script setup>
defineProps({
	openinghours: { type: String, default: '' },
});

const { data: footer } = await useWebsiteFetch('footermenu');
const { footermenu } = footer.value;

const { locale } = useI18n();
const { defaults, fetchDefaults } = useDefaults();
const { openConsent } = useCookieConsent();

await fetchDefaults();
</script>

<style lang="scss" scoped>
footer {
	font-size: 15px;
}

.footer-nav {
	margin: 0;
	text-align: left;
	padding: 40px 30px 80px;
	background: var(--primary-background-color);
	display: flex;
	flex-flow: row wrap;
	justify-content: space-between;
	align-items: flex-end;
	color: var(--secondary-background-color);

	p,
	:deep(p) {
		margin: 0;
	}

	.align-right {
		span {
			width: 100%;
		}
	}

	a {
		display: inline-block;
		font-size: 15px;
		text-decoration: none;
		margin: 0;
		color: var(--secondary-background-color);

		&:hover {
			color: var(--cta-color);
		}
	}

	span {
		display: inline-block !important;
		width: auto;

		span {
			margin: 0 5px;
		}
	}
}

@media (max-width: 900px) {
	.footer-nav {
		padding: 40px 30px 80px;

		.columns {
			width: 100%;
			text-align: left;
			margin: 0 auto 40px;
		}

		a {
			margin: 0;
		}

		.align-right {
			text-align: left;

			span {
				width: 100%;
			}

			a {
				margin: 0 10px 0 0;
			}
		}
	}
}

@media (max-width: 600px) {
	.footer-nav {
		padding: 40px 10px 80px;
	}
}
</style>
